import React, { useState } from 'react';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import '../../assets/css/animated.css';
import Box from '@mui/material/Box';
import { Link } from "react-router-dom";
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Banner from '../../assets/images/banner.svg';
import MyselfBg from '../../assets/images/myselfbg.png';
import IconButton from '@mui/material/IconButton';
import ForMySelfWhite from '../../assets/images/myself-white.svg';
import ForMyselfBlue from '../../assets/images/Myself-blue.svg';
import ForMyChildWhite from '../../assets/images/formychild-white.svg';
import ForMyChildBlue from '../../assets/images/formychild-blue.svg';
import DecidingScreengoout from '../../assets/images/decidingscreengoout.svg';
const Item1 = styled(Box)(({ theme, isSelected }) => ({
  backgroundColor: isSelected ? '#DFF0FF' : (theme.palette.mode === 'dark' ? '#1A2027' : '#fff'),
  ...theme.typography.body2,
  padding: theme.spacing(1),
  color: theme.palette.text.secondary,
  cursor: 'pointer',
  transition: 'background-color 0.3s',
  borderBottomRightRadius: isSelected ? '16px' :'12px',
  borderBottomLeftRadius: isSelected ? '16px' :'12px',
  borderTopLeftRadius: isSelected ? '25px' :'20px',
  borderTopRightRadius: isSelected ? '25px' :'20px',
  border: isSelected ? '5px solid blue' : `1px solid ${theme.palette.mode === 'dark' ? '#858585' : '#858585'}`,
  '&:hover': {
    backgroundColor: isSelected ? '#DFF0FF' : (theme.palette.mode === 'dark' ? '#0D3843' : '#f0f0f0'),
  },
  padding: '50px',
  textAlign: 'left',
  position: 'relative',
  width: '70vw',
  height: '25vw',
  "@media (max-width: 600px)": {width: '50vw',height: '30vw',
    borderBottomRightRadius: isSelected ? '18px' :'10px',
  borderBottomLeftRadius: isSelected ? '16px' :'10px',
  borderTopLeftRadius: isSelected ? '18px' :'10px',
  borderTopRightRadius: isSelected ? '18px' :'10px',
  }
}));
const Item2 = styled(Box)(({ theme, isSelected }) => ({
  backgroundColor: isSelected ? '#DFF0FF' : (theme.palette.mode === 'dark' ? '#1A2027' : '#fff'),
  ...theme.typography.body2,
  padding: theme.spacing(1),
  color: theme.palette.text.secondary,
  cursor: 'pointer',
  transition: 'background-color 0.3s',
  borderBottomRightRadius: isSelected ? '16px' : '11px',
  borderBottomLeftRadius: isSelected ? '16px' : '12px',
  borderTopLeftRadius: isSelected ? '32px' : '28px',
  borderTopRightRadius: isSelected ? '32px' : '28px',
  border: isSelected ? '5px solid blue' : `1px solid ${theme.palette.mode === 'dark' ? '#858585' : '#858585'}`,
  '&:hover': {
    backgroundColor: isSelected ? '#DFF0FF' : (theme.palette.mode === 'dark' ? '#0D3843' : '#f0f0f0'),
  },
  padding: '50px',
  textAlign: 'left',
  position: 'relative',
  width: '70vw',
  height: '25vw',
  "@media (max-width: 600px)": {width: '50vw',height: '30vw',
    borderBottomRightRadius: isSelected ? '18px' :'10px',
  borderBottomLeftRadius: isSelected ? '16px' :'10px',
  borderTopLeftRadius: isSelected ? '18px' :'10px',
  borderTopRightRadius: isSelected ? '18px' :'10px',
  }
}));

function DecidingScreen() {
  const [selectedOption, setSelectedOption] = useState(null);
  const isButtonDisabled = selectedOption === null;

  const handleOptionSelect = (option) => {
    setSelectedOption(option);
  };

  const handleProceed = () => {
    if (selectedOption === 'Myself') {
      window.location.href = '/signup';
    } else if (selectedOption === 'ForMyChild') {
      window.location.href = '/parentInformation';
    }
  };

  // const handleProceedClick = () => {
  //   handleCloseDecidingScreen();
  // };
  const styles = {
    typography: {
      fontFamily:'Sofia Sans Extra Condensed',
        fontSize: '3rem',
        fontWeight: 700,
        lineHeight: '60px',
        letterSpacing: '0em',
        textAlign: 'center',
      '@media (max-width: 600px)': {
        fontSize: '2rem', // Adjust the font size for smaller screens
        
        lineHeight: '30px',
      },
    },
    // Other styles...
  };
  const handleClose = () => {
    // Close the modal (if applicable)
    // Navigate one page back in the browser history
    window.history.back();
  };
  return (
    <div style={{ width: '100%' }}>
      <Box sx={{ padding: '20px 50px',"@media (max-width: 600px)": {padding:'10px',display:'flex',justifyContent:'center',flexDirection:'column',alignItems:'center'}}}>
        <div style={{ display: 'flex', padding:"10px", alignItems: 'center' }}>
          <img src={Banner} alt="" />
        </div>
         <Box sx={{ borderRadius:'30px',backgroundColor:'#F1F1F1',padding: '30px',"@media (max-width: 600px)": {padding:'10px',display:'flex',justifyContent:'center',flexDirection:'column',alignItems:'center'}}}>
          <Box sx={{display:"flex",alignItems:"center",justifyContent:'center',gap:'50px',"@media (max-width: 600px)": {alignItems:'flex-start',gap:'10px',}}}>
        <IconButton
          edge="end"
          color="error"
          onClick={handleClose} // Call the function to close the modal
          aria-label="close"
        
        >
          <img src={DecidingScreengoout} alt="" />
        </IconButton>

        <Typography sx={{ color: '#1E53E8',...styles.typography, textAlign: 'center'}}>
          Who will be using this MegaConnect PC?
        </Typography>
        </Box>
        <Stack spacing={2} direction={{ xs: 'column', sm: 'row' }} sx={{ marginTop: '5px' }}>
          <Item2 isSelected={selectedOption === 'Myself'} onClick={() => handleOptionSelect('Myself')}>
            <div className='myself-container'>
              <div className="myself-bg-img"></div>
              {selectedOption !== 'Myself' &&
                <div className='without-hoverimg-colorshade'>
                  <img src={ForMySelfWhite} alt="" />
                  <Typography sx={{ color: "#fff", fontFamily: 'Poppins', fontSize: '58px', fontStyle: 'normal', fontWeight: 900, lineHeight: 'normal',"@media (max-width: 600px)": {fontSize:'32px'} }}>
                    Myself
                  </Typography>
                </div>
              }
              {selectedOption === 'Myself' &&
                <div className="after-hovering-card-visible">
                  <Box sx={{margin: '0px',
  padding: '30px',
  "@media (max-width: 600px)": {padding:'0px'},
  backgroundColor: "rgba(255, 255, 255, 0.7)",
  borderRadius: '15px',
  display: 'flex',
  justifyContent: 'center',
  alignItems:'center',
  flexDirection: 'column',
  width: '100%',
  height: '200px',
  backdropFilter: 'blur(0px)', /* Apply a blur effect to the background */
  border: '1px solid rgba(255, 255, 255, 0.5)', /* Add a subtle white border */
  boxShadow: '0px 8px 15px rgba(0, 0, 0, 0.1)', }}>
                    <img src={ForMyselfBlue} alt="" width={'20%'}  />
                    <Typography sx={{ color: "#1E53E8", fontFamily: 'Poppins', fontSize: '48px', fontStyle: 'normal', fontWeight: 900, lineHeight: 'normal',"@media (max-width: 600px)": {fontSize:'28px'} }}>
                    Myself
                  </Typography>
                    <Typography sx={{ textAlign:'center',color: '#000', fontFamily: 'Poppins', fontSize: '16px', fontStyle: 'normal', fontWeight: 300, lineHeight: 'normal',"@media (max-width: 600px)": {fontSize:'12px',} }}>
                      Boost your productivity, unleash your creativity, and explore limitless learning with your own powerful PC. Take control and unlock your full potential.
                    </Typography>
                  </Box>
                </div>
              }
            </div>
          </Item2>
          <Item1 isSelected={selectedOption === 'ForMyChild'} onClick={() => handleOptionSelect('ForMyChild')}>
            <div className='myself-container'>
              <div className="mychild-bg-img"></div>
              {selectedOption !== 'ForMyChild' &&
                <div className='without-hoverimg-colorshade'>
                  <img src={ForMyChildWhite} alt="" />
                  <Typography sx={{ color: "#fff", fontFamily: 'Poppins', fontSize: '58px', fontStyle: 'normal', fontWeight: 900, lineHeight: 'normal',"@media (max-width: 600px)": {fontSize:'28px'}}}>
                    For my Child
                  </Typography>
                </div>
              }
              {selectedOption === 'ForMyChild' &&
                <div className="after-hovering-card-visible">
                  <Box sx={{margin: '0px',
  padding: '30px',
  "@media (max-width: 600px)": {padding:'0px'},
  backgroundColor: "rgba(255, 255, 255, 0.7)",
  borderRadius: '15px',
  display: 'flex',
  justifyContent: 'center',
  alignItems:'center',
  flexDirection: 'column',
  width: '100%',
  height: '200px',
  backdropFilter: 'blur(0px)', /* Apply a blur effect to the background */
  border: '1px solid rgba(255, 255, 255, 0.5)', /* Add a subtle white border */
  boxShadow: '0px 8px 15px rgba(0, 0, 0, 0.1)', }}>
                    <img src={ForMyChildBlue} alt="" width={'20%'} />
                    <Typography sx={{ color: "#1E53E8", fontFamily: 'Poppins', fontSize: '48px', fontStyle: 'normal', fontWeight: 900, lineHeight: 'normal',"@media (max-width: 600px)": {fontSize:'28px',} }}>
                    For my Child
                  </Typography>
                    <Typography sx={{textAlign:'center', color: '#000', fontFamily: 'Poppins', fontSize: '16px', fontStyle: 'normal', fontWeight: 300, lineHeight: 'normal',"@media (max-width: 600px)": {fontSize:'12px',} }}>
                      Set boundaries, monitor activity, and encourage responsibility. MegaConnect PC empowers you to guide your child's digital journey.
                    </Typography>
                  </Box>
                </div>
              }
            </div>
          </Item1>
        </Stack>
        <div style={{display:'flex',justifyContent:'center'}}>
        <Button
                  sx={{fontFamily: "Roboto Flex", textAlign: "center", marginTop: "30px",background:'#C7F760',color:'#1E53E8',width:'500px','&:hover': {
                    color: 'white',
                  },
                  "@media (max-width: 600px)": {width:'250px'} }}
                  variant="contained"
                  onClick={handleProceed}
                  disabled={isButtonDisabled}
              >
                  Proceed
              </Button>
              </div>
              </Box>
      </Box>
    </div>
  );
}

export default DecidingScreen;
